import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { IApiResponse } from "@models/http/http-options";
import { environment } from "src/environments/environment";
import { BaseService } from "./base.service";
import { FileStorageEndpoints } from "@dmms/shared/data-access/file-storage/types/file-storage-endpoints";
import { IReportResult } from "@models/reports/reports";

@Injectable({
  providedIn: "root",
})
export class FileApiService extends BaseService {
  getExport(
    dicType: string,
    params: any,
    version = 1,
  ): Observable<IApiResponse<IReportResult>> {
    return this.post(`v${version}/${dicType}`, params);
  }

  getTemplateExport(
    dicType: string,
    params: any,
    version = 1,
  ): Observable<IApiResponse<IReportResult>> {
    return this.get(`v${version}/${dicType}`, params);
  }

  deleteFile(dicType: string, filePath: string, version = 1) {
    return this.remove(`v${version}/${dicType}/${filePath}`);
  }

  getPhoto(photoPath: string, version = 1): Observable<Blob> {
    return this.http.get(
      `${environment.apiUrl}v${version}/${FileStorageEndpoints.FileStorage}/${photoPath}`,
      {
        responseType: "blob",
      },
    );
  }

  downloadTextFile(
    dicType: string,
    id: string,
    version = 1,
  ): Observable<string> {
    return this.http.get(`${environment.apiUrl}v${version}/${dicType}/${id}`, {
      responseType: "text",
    });
  }
}
